import React from 'react';

import { clsx } from 'clsx';

import { TravelLoyaltyIcons } from 'src/components/pages/PartnersPage/types';

import styles from './IconBlock.scss';

type Props = {
  item: TravelLoyaltyIcons;
  className?: string;
};

const IconBlock = ({ item, className }: Props) => (
  <div className={styles.iconBlock}>
    <div className={styles.iconWrapper}>
      <img src={item.icon} className={clsx(styles.icon, className)} alt="" />
    </div>
    <div className={styles.text} dangerouslySetInnerHTML={{ __html: item.text }} />
  </div>
);

export default IconBlock;
